"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icons = _interopRequireDefault(require("../../styles/icons"));

var _colors = _interopRequireDefault(require("./colors"));

var _theme = require("../../styles/theme");

var iconVariants = _interopRequireWildcard(require("./styles"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var getDefaultColor = function getDefaultColor(props) {
  if (props.color) {
    return props.color;
  }

  if (_colors.default[props.type]) {
    return _colors.default[props.type].normal;
  }

  return '';
};

var Icon = (
/*#__PURE__*/
0, _styledBase.default)('i', {
  target: "eeqdolf0",
  label: "Icon"
})("font-style:inherit;color:", function (props) {
  return getDefaultColor(props);
}, ";display:inline-flex;align-items:center;justify-content:center;text-align:center;&::before{", _theme.fonts.icons, ";content:\"", function (props) {
  return _icons.default[props.type];
}, "\";line-height:inherit;color:inherit;}&:hover{color:", function (props) {
  return _colors.default[props.type] ? _colors.default[props.type].hover : '';
}, ";}", function (props) {
  return props.withText ? iconVariants.withText : '';
}, ";", function (props) {
  return props.withTextLeft ? iconVariants.withTextLeft : '';
}, ";", function (props) {
  return props.fixedWidth ? iconVariants.fixedWidth : '';
}, ";", function (props) {
  return props.flip ? iconVariants.flip : '';
}, ";", function (props) {
  return props.spin ? iconVariants.spin : '';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
exports.Icon = Icon;
Icon.defaultProps = {
  withText: false,
  withTextLeft: false,
  fixedWidth: true,
  spin: '',
  flip: '',
  color: null,
  children: null
};
Icon.propTypes = {
  withText: _propTypes.default.bool,
  withTextLeft: _propTypes.default.bool,
  spin: _propTypes.default.string,
  fixedWidth: _propTypes.default.bool,
  flip: _propTypes.default.string,
  type: _propTypes.default.string.isRequired,
  color: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string])
};